import type {ComponentValue} from './components/types'

export const PLAN_FIELDS = {
  lifestyleAdviceOnly: 'Lifestyle advice only',
  lifestyleAdviceAndFutureGpVisit: 'Lifestyle advice and future GP visit',
  gpVisit: 'Recommend visit to GP (within 3-4 weeks)',
  gpVisitDetails: 'Recommend visit to GP (within 3-4 weeks) - Details',
  emergencyDepartment: 'Recommend visit to Emergency Department',
  emergencyDepartmentDetails:
    'Recommend visit to Emergency Department - Details',
} as const

export const PLAN_RECOMMENDATIONS = [
  'None',
  PLAN_FIELDS.lifestyleAdviceOnly,
  PLAN_FIELDS.lifestyleAdviceAndFutureGpVisit,
  PLAN_FIELDS.gpVisit,
  PLAN_FIELDS.emergencyDepartment,
] as const

export type PlanRecommendation = (typeof PLAN_RECOMMENDATIONS)[number]

export const PERSISTED_PLAN_FIELDS = [
  PLAN_FIELDS.lifestyleAdviceOnly,
  PLAN_FIELDS.lifestyleAdviceAndFutureGpVisit,
  PLAN_FIELDS.gpVisit,
  PLAN_FIELDS.gpVisitDetails,
  PLAN_FIELDS.emergencyDepartment,
  PLAN_FIELDS.emergencyDepartmentDetails,
] as const

const getValue = (data: ComponentValue[], name: string) =>
  data.find((item) => item.name === name)?.value

export const getPlanRecommendation = (
  data: ComponentValue[],
): PlanRecommendation => {
  if (getValue(data, PLAN_FIELDS.emergencyDepartment) === 'Yes') {
    return PLAN_FIELDS.emergencyDepartment
  }
  const gpVisit = getValue(data, PLAN_FIELDS.gpVisit)
  if (gpVisit === 'Own' || gpVisit === 'Centric Health') {
    return PLAN_FIELDS.gpVisit
  }
  if (getValue(data, PLAN_FIELDS.lifestyleAdviceAndFutureGpVisit) === 'Yes') {
    return PLAN_FIELDS.lifestyleAdviceAndFutureGpVisit
  }
  if (getValue(data, PLAN_FIELDS.lifestyleAdviceOnly) === 'Yes') {
    return PLAN_FIELDS.lifestyleAdviceOnly
  }
  return 'None'
}

export const isCentricHealthRecommendation = (data: ComponentValue[]) =>
  getValue(data, PLAN_FIELDS.gpVisit) === 'Centric Health'

const getGpRecommendationValue = (useCentricHealth: boolean) =>
  useCentricHealth ? 'Centric Health' : 'Own'

export const getPlanRecommendationUpdates = (
  recommendation: PlanRecommendation,
  useCentricHealth = false,
): ComponentValue[] => {
  const updates: ComponentValue[] = [
    {
      name: PLAN_FIELDS.lifestyleAdviceOnly,
      value: recommendation === PLAN_FIELDS.lifestyleAdviceOnly ? 'Yes' : 'No',
    },
    {
      name: PLAN_FIELDS.lifestyleAdviceAndFutureGpVisit,
      value:
        recommendation === PLAN_FIELDS.lifestyleAdviceAndFutureGpVisit
          ? 'Yes'
          : 'No',
    },
    {
      name: PLAN_FIELDS.gpVisit,
      value:
        recommendation === PLAN_FIELDS.gpVisit
          ? getGpRecommendationValue(useCentricHealth)
          : 'No',
    },
    {
      name: PLAN_FIELDS.emergencyDepartment,
      value: recommendation === PLAN_FIELDS.emergencyDepartment ? 'Yes' : 'No',
    },
  ]

  if (recommendation !== PLAN_FIELDS.gpVisit) {
    updates.push({name: PLAN_FIELDS.gpVisitDetails, value: ''})
  }
  if (recommendation !== PLAN_FIELDS.emergencyDepartment) {
    updates.push({name: PLAN_FIELDS.emergencyDepartmentDetails, value: ''})
  }

  return updates
}
